module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "first"
    }
  }, [_c('teamList', {
    attrs: {
      "view": 0
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "拼团中",
      "name": "second"
    }
  }, [_c('teamList', {
    attrs: {
      "view": 1
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "拼团成功",
      "name": "third"
    }
  }, [_c('teamList', {
    attrs: {
      "view": 2
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "拼团失败",
      "name": "fourth"
    }
  }, [_c('teamList', {
    attrs: {
      "view": 3
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ce3a9f94", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce3a9f94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/groups/team.vue
// module id = 2934
// module chunks = 0